import styled, { css, keyframes } from "styled-components";
import { Container } from "reactstrap";
import { theme } from "../../constants/theme";

const HeaderCSS = css`
  background-image: url(${({ image }) =>
    image || "../../assets/img/landing-page-image-2.jpg"});
  background-size: cover;
  background-position: center;
  position: relative;

  /* Warm slate-tinted scrim — readable without feeling like a plain black veil */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      120deg,
      rgba(31, 41, 55, 0.62) 0%,
      rgba(46, 58, 82, 0.48) 55%,
      rgba(46, 58, 82, 0.28) 100%
    );
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  /* Hide the legacy .filter overlay — our gradient scrim replaces it */
  .filter {
    display: none;
  }
`;

const fadeUp = keyframes`
  from { transform: translateY(14px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

export const HeaderContainer = styled.div`
  ${HeaderCSS}

  min-height: 72vh;
  display: flex;
  align-items: center;

  @media (max-width: 998.98px) {
    min-height: 82vh;
    padding-bottom: 3rem;
  }

  @media (max-height: 870px) {
    min-height: 80vh;
  }
`;

export const MottoHeaderContainer = styled(Container)`
  padding-top: 2rem;
  padding-bottom: 2rem;

  .motto {
    animation: ${fadeUp} 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) both;
  }

  .motto > * {
    animation: ${fadeUp} 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) both;
  }

  /* Stagger the hero elements */
  .motto > *:nth-child(1) { animation-delay: 0.05s; }
  .motto > *:nth-child(2) { animation-delay: 0.18s; }
  .motto > *:nth-child(3) { animation-delay: 0.32s; }

  @media (max-height: 870px) {
    margin-top: 4rem;
  }
`;

export const HeaderTitle = styled.h1`
  font-family: ${theme.font.display};
  font-weight: 500;
  font-size: clamp(2.5rem, 5vw + 1rem, 4.25rem);
  line-height: 1.02;
  letter-spacing: -0.035em;
  margin-bottom: 1.25rem;
  color: #FDFBF7;
  font-variation-settings: "opsz" 120;
  text-wrap: balance;

  /* Subtle italic serif accent on a single word via optional span wrapping */
  em {
    font-style: italic;
    color: ${theme.color.salmonSoft};
  }
`;

export const HeaderSubtitleContainer = styled.div`
  max-width: 560px;

  h3 {
    font-family: ${theme.font.body};
    font-size: 1.125rem;
    line-height: 1.55;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 0.5rem;
    color: rgba(253, 251, 247, 0.92);
    letter-spacing: -0.005em;
  }

  h3.pricing-tagline {
    display: inline-block;
    margin-top: 1rem;
    padding: 0.45rem 0.85rem;
    background: rgba(253, 251, 247, 0.12);
    border: 1px solid rgba(253, 251, 247, 0.22);
    border-radius: ${theme.radius.pill};
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    font-size: 0.875rem;
    font-weight: 500;
    color: #FDFBF7;
    letter-spacing: 0.005em;
  }

  @media (max-width: 767.98px) {
    max-width: 100%;
  }
`;

export const FreeAssessmentHeaderContainer = styled.div`
  ${HeaderCSS}

  background-position-y: 10%;
  min-height: ${({ minHeight }) => minHeight || "20vh"};
`;

export const AboutHeaderContainer = styled.div`
  ${HeaderCSS}

  min-height: 20vh;

  .container {
    .motto {
      padding: 5rem 1.2rem 3rem 1.2rem;

      h1 {
        font-family: ${theme.font.display};
        font-weight: 500;
        color: #FDFBF7;
        text-align: center;
        font-size: clamp(2rem, 4vw + 1rem, 3rem);
        letter-spacing: -0.025em;
      }
    }
  }
`;
